import React, { Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import PublicLayout from './components/layout/PublicLayout'
import UserDashboardLayout from './components/layout/UserDashboardLayout'
import AdminDashboardLayout from './components/layout/AdminDashboardLayout'
import ProtectedRoute from './components/auth/ProtectedRoute'
import AdminProtectedRoute from './components/auth/AdminProtectedRoute'
import Home from './pages/Home'
import ClientArea from './pages/ClientArea'
import WipPage from './pages/WipPage'
import AdminUsuariosPage from './pages/admin/AdminUsuariosPage'
import AdminUsuarioCompletoPage from './pages/admin/AdminUsuarioCompletoPage'
import AdminVipUsuariosPage from './pages/admin/AdminVipUsuariosPage'
import AdminPacotesPage from './pages/admin/AdminPacotesPage'
import AdminPacoteEditPage from './pages/admin/AdminPacoteEditPage'
import AdminEstatisticasPage from './pages/admin/AdminEstatisticasPage'
import PalworldItemsPage from './pages/palworld/PalworldItemsPage'
import PalworldKitsIniciaisPage from './pages/admin/PalworldKitsIniciaisPage'
import PalworldOnlinePlayersPage from './pages/admin/PalworldOnlinePlayersPage'
import CheckoutPage from './components/checkout/CheckoutPage'
import WarzoneCoinsExtratoPage from './pages/WarzoneCoinsExtratoPage'
import MeuPerfilPage from './pages/MeuPerfilPage'
import MeusPedidosPage from './pages/MeusPedidosPage'
import ItensPendentesEntregaPage from './pages/ItensPendentesEntregaPage'
import ComoFuncionaPage from './pages/ComoFuncionaPage'
import RegrasPage from './pages/RegrasPage'

const AdminPagamentosPage = lazy(() => import('./pages/admin/AdminPagamentosPage'))

const App: React.FC = () => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/como-funciona" element={<ComoFuncionaPage />} />
        <Route path="/regras" element={<RegrasPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
      </Route>

      <Route path="/cliente" element={<ClientArea />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <UserDashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="perfil" replace />} />
        <Route path="perfil" element={<MeuPerfilPage />} />
        <Route path="eventos" element={<WipPage title="Eventos" />} />
        <Route path="pedidos" element={<MeusPedidosPage />} />
        <Route path="itens-pendentes-entrega" element={<ItensPendentesEntregaPage />} />
        <Route path="estatisticas" element={<WipPage title="Estatísticas" />} />
        <Route path="denuncias" element={<WipPage title="Denúncias" />} />
        <Route path="itens" element={<PalworldItemsPage />} />
        <Route path="coins" element={<WarzoneCoinsExtratoPage />} />
      </Route>

      <Route
        path="/admin"
        element={
          <AdminProtectedRoute>
            <AdminDashboardLayout />
          </AdminProtectedRoute>
        }
      >
        <Route index element={<Navigate to="usuarios" replace />} />
        <Route path="usuarios" element={<AdminUsuariosPage />} />
        <Route path="usuarios/:userId" element={<AdminUsuarioCompletoPage />} />
        <Route path="vip" element={<AdminVipUsuariosPage />} />
        <Route path="pacotes" element={<AdminPacotesPage />} />
        <Route path="pacotes/:id" element={<AdminPacoteEditPage />} />
        <Route path="eventos" element={<WipPage title="Eventos" />} />
        <Route
          path="pagamentos"
          element={
            <Suspense
              fallback={
                <Box sx={{ minHeight: '60dvh', display: 'grid', placeItems: 'center' }}>
                  <CircularProgress />
                </Box>
              }
            >
              <AdminPagamentosPage />
            </Suspense>
          }
        />
        <Route path="cupons" element={<WipPage title="Gerenciar Cupons" />} />
        <Route path="denuncias" element={<WipPage title="Gerenciar Denúncias" />} />
        <Route path="estatisticas" element={<AdminEstatisticasPage />} />
        <Route path="itens" element={<PalworldItemsPage />} />
        <Route path="kits-iniciais" element={<PalworldKitsIniciaisPage />} />
        <Route path="online" element={<PalworldOnlinePlayersPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
